import React,{useState,}from 'react'
import { UploadOutlined,} from '@ant-design/icons';
import { Button,Modal,message,Form,Input,Upload, Select,} from 'antd';
import { useAddSystemMutation,  } from '../store/ReactWebSiteApi';
import MyEditor from '../cpn/MyEditor';
import {appType} from './appType'
import { appPayType } from './appType';
function AppAdd() {
    //上传首页图片
    const homeChange = (e) => {
        if (e.file.status === 'done'||e.file.status==='removed') {
            const fileArr = e.fileList.map((item) => {
                const { response } = item
                return response.Result
            })
            console.log(e);
            let fileStr = fileArr + "";  
            if(fileStr === null){
                fileStr = ''
            }
            setInfo(prevState=>({...prevState,esv_image_name:fileStr}))
        }
    }
    //上传列表图片
    const listChange = (e) => {
        if (e.file.status === 'done'||e.file.status==='removed') {
            const fileArr = e.fileList.map((item) => {
                const { response } = item
                return response.Result
            })
            console.log(e);
            let fileStr = fileArr + "";  
            if(fileStr === null){
                fileStr = ''
            }
            setInfo(prevState=>({...prevState,esv_image2_name:fileStr}))
        }
    }
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateAdd = (values) => {
        console.log('Received values of form: ', values);
        systemAdd(info).then((res) => {
            if (res.data.Status === 'success') {
                message.info('新增成功！');
                setOpen(false);
            }
            if (res.data.Status === "fail") {
                message.error('新增失败！'+res.data.Message)
            }
        })
        
    };
    const [info,setInfo] = useState({
        esv_uid:localStorage.getItem('eu_id'),
        esv_uname:localStorage.getItem('eu_name'),
        esv_remark:'',
        
    });
    const [systemAdd] = useAddSystemMutation()
  return (
        <>
            <a onClick={() => {setOpen(true)}}>新增</a>
            <Modal
                width={1000}
                open={open}
                title='新增产品'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateAdd(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_add"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                >
                    <Form.Item name="class" label='品牌平台' wrapperCol={{span:10}} required>
                        <Select options={appType} onChange={(e) => {setInfo(prevState=>({...prevState,esv_type_id:e}))}}/>
                    </Form.Item>
                    <Form.Item name="name" label='产品名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,esv_name:e.target.value}))}}/>
                    </Form.Item>                    
                    <Form.Item name="esv_cost_type" label='收费类型' wrapperCol={{span:10}} required>
                        <Select options={appPayType} onChange={(e) => {setInfo(prevState=>({...prevState,esv_cost_type:e}))}}/>
                    </Form.Item>
                    <Form.Item label="官网广告图"                         
                        valuePropName='fileList'
                        getValueFromEvent={e => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            return e && e.fileList;
                        }}
                    >
                        <Upload
                            name="image_file"
                            action="/api/ReactApi/zd_single_upload_image"
                            listType="picture"
                            className="upload-list-inline"
                            onChange={homeChange}
                            maxCount={1}
                            >
                            <Button icon={<UploadOutlined />}>点击上传</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item label="产品图标"                         
                        valuePropName='fileList'
                        getValueFromEvent={e => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            return e && e.fileList;
                        }}
                    >
                        <Upload
                            name="image_file"
                            action="/api/ReactApi/zd_single_upload_image"
                            listType="picture"
                            className="upload-list-inline"
                            onChange={listChange}
                            maxCount={1}
                            >
                            <Button icon={<UploadOutlined />}>点击上传</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item name="remark" label='用户需求' wrapperCol={{span:15}} required>
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,esv_remark:e}))}}  value={info.esv_content}/>
                    </Form.Item>
                    <Form.Item name="content" label='收费方式' wrapperCol={{span:15}} >
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,esv_content:e}))}} value={info.esv_remark}/>
                    </Form.Item>                    
                    <Form.Item name="route" label='路由' wrapperCol={{span:15}}>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,esv_router:e.target.value}))}}/>
                    </Form.Item>                    
                </Form>
            </Modal>
        </>
    )
}

export default AppAdd